import { Flame, Phone, Mail } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, ADDRESS } from "@/lib/hours";

export default function Footer() {
  return (
    <footer id="contact" data-testid="main-footer" className="border-t border-border/60 bg-surface-1">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-20 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-12 lg:flex-row lg:items-end">
          <div>
            <p className="overline-label">À très vite</p>
            <div className="mt-5">
              <img src="/images/palmi-logo.png" alt="PALMI Pizza Club" className="logo-mark h-20 w-auto sm:h-24" />
            </div>
          </div>
          <div className="space-y-3 text-sm text-dim">
            <p className="flex items-center gap-2.5"><Flame size={15} className="text-terra" /> {ADDRESS}</p>
            <a data-testid="footer-phone-link" href={PHONE_TEL} className="flex items-center gap-2.5 transition-colors hover:text-terra">
              <Phone size={15} className="text-terra" /> {PHONE_DISPLAY}
            </a>
            <a
              data-testid="footer-email-link"
              href="mailto:contact@palmipizzaclub.fr"
              className="flex items-center gap-2.5 transition-colors hover:text-terra"
            >
              <Mail size={15} className="text-terra" /> contact@palmipizzaclub.fr
            </a>
          </div>
        </div>
        <div className="mt-16 flex flex-col items-start justify-between gap-3 border-t border-border/50 pt-6 text-xs text-dim sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} PALMI Pizza Club — Pizzas artisanales à emporter à Arnas</p>
          <p className="font-code uppercase tracking-[0.2em]">Mentions légales · Fait avec feu et farine</p>
        </div>
      </div>
    </footer>
  );
}
